import { render } from "./DetalharEventoConfiguracao.vue?vue&type=template&id=08c8bb0a"
import script from "./DetalharEventoConfiguracao.vue?vue&type=script&lang=js"
export * from "./DetalharEventoConfiguracao.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__